import Modal from 'antd/lib/modal'
import './index.less'

export default Modal



// WEBPACK FOOTER //
// ./src/elements/modal/index.js